module.exports = __webpack_public_path__ + "img/202402_01_sp.9de5ef24.jpg";